import { useLayoutEffect, useState } from "react";
export default function useDocumentSize() {
    const [documentSize, setDocumentSize] = useState({
        height: document.documentElement.scrollHeight,
        width: document.documentElement.scrollWidth,
    });
    const onResize = () => {
        setDocumentSize({
            height: document.documentElement.scrollHeight,
            width: document.documentElement.scrollWidth,
        });
    };
    useLayoutEffect(() => {
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);
    return documentSize;
}
